// Google Ads / Consent Mode helpers (LGPD).
export const ADS_ID = "AW-18467958859";

// Cole aqui o rótulo da ação de conversão do Google Ads (parte após a barra),
// ex.: "AbCd-EfGhIjk" — o gtag disparará send_to = `${ADS_ID}/${ADS_CONVERSION_LABEL}`.
export const ADS_CONVERSION_LABEL = "";

const KEY = "gm2_consent";

export function consentChoice() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
}
export function hasConsentChoice() {
    return consentChoice() === "granted" || consentChoice() === "denied";
}
export function grantConsent() {
    try { localStorage.setItem(KEY, "granted"); } catch (e) {}
    if (window.gtag) {
        window.gtag("consent", "update", {
            ad_storage: "granted", analytics_storage: "granted",
            ad_user_data: "granted", ad_personalization: "granted",
        });
    }
}
export function denyConsent() {
    try { localStorage.setItem(KEY, "denied"); } catch (e) {}
    if (window.gtag) {
        window.gtag("consent", "update", {
            ad_storage: "denied", analytics_storage: "denied",
            ad_user_data: "denied", ad_personalization: "denied",
        });
    }
}

// Dispara a conversão de assinatura concluída (idempotente por transaction_id nesta sessão).
export function fireSubscriptionConversion(orderId) {
    if (!ADS_CONVERSION_LABEL || !window.gtag) return;
    try {
        const flag = "gm2_conv_" + (orderId || "sub");
        if (sessionStorage.getItem(flag)) return;
        sessionStorage.setItem(flag, "1");
    } catch (e) {}
    window.gtag("event", "conversion", {
        send_to: `${ADS_ID}/${ADS_CONVERSION_LABEL}`,
        ...(orderId ? { transaction_id: orderId } : {}),
    });
}
